import { useEffect, useState } from "react";
import api from "@/lib/api";
import { devDebug } from "@/lib/debug";

/**
 * Fetches recent spb.verify_failed audit entries + a 7-day count summary.
 * Returns { items, count7d, loading, reload }.
 */
export function useFraudSummary({ recentLimit = 5, windowDays = 7 } = {}) {
  const [items, setItems] = useState([]);
  const [count7d, setCount7d] = useState(0);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/audit", {
        params: { action: "spb.verify_failed", limit: recentLimit },
      });
      setItems(data);

      const sinceDate = new Date(Date.now() - windowDays * 86400 * 1000)
        .toISOString().slice(0, 10);
      const cnt = await api.get("/audit", {
        params: {
          action: "spb.verify_failed",
          date_from: sinceDate,
          limit: 500,
        },
      });
      setCount7d((cnt.data || []).length);
    } catch (err) {
      devDebug("useFraudSummary load failed", err);
      setItems([]);
      setCount7d(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // Only re-fetch if limit/window change; parent shouldn't need to force reload
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recentLimit, windowDays]);

  return { items, count7d, loading, reload: load };
}

/** Human-readable label for the meta.reason enum. */
export function reasonLabel(meta) {
  const r = meta?.reason || "unknown";
  return {
    invalid_qr_format: "Format QR salah",
    spb_not_found:     "SPB tidak ada di sistem",
    plate_mismatch:    "Nomor polisi tidak cocok",
    cancelled:         "SPB sudah dibatalkan",
  }[r] || r;
}
